/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminGetUserPinPathParameters } from 'api/actions/admin-get-user-pin/admin-get-user-pin-path-parameters';
import { AdminGetUserPinResponse } from 'api/actions/admin-get-user-pin/admin-get-user-pin-response';

type AdminGetUserPinQueryParameters = Record<string, any>;

/**
 * The path of the AdminGetUserPin action.
 */
export const adminGetUserPinActionPath = new SweetPath<keyof AdminGetUserPinPathParameters>(
  '/admin/custom/user-pin/{userId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized AdminGetUserPin actions.
 */
export default function createAdminGetUserPinAction(axios: AxiosInstance) {
  return function adminGetUserPinAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminGetUserPinPathParameters;
    query?: AdminGetUserPinQueryParameters;
  }) {
    const path = adminGetUserPinActionPath.insert(parameters);

    return axios.get<AdminGetUserPinResponse, AdminGetUserPinResponse>(path, { params: query, headers });
  };
}
